import script from "./VehicelsTemperatureList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicelsTemperatureList.vue?vue&type=script&setup=true&lang=ts"

import "./VehicelsTemperatureList.vue?vue&type=style&index=0&id=130fdcbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-130fdcbe"]])

export default __exports__